__turbopack_context__.v({
  "button": "TipTapComposer-module-scss-module__p3KxnW__button",
  "buttonLoader": "TipTapComposer-module-scss-module__p3KxnW__buttonLoader",
  "composer": "TipTapComposer-module-scss-module__p3KxnW__composer",
  "file": "TipTapComposer-module-scss-module__p3KxnW__file",
  "filePreview": "TipTapComposer-module-scss-module__p3KxnW__filePreview",
  "filePreviewDelete": "TipTapComposer-module-scss-module__p3KxnW__filePreviewDelete",
  "files": "TipTapComposer-module-scss-module__p3KxnW__files",
  "filesPreview": "TipTapComposer-module-scss-module__p3KxnW__filesPreview",
  "footer": "TipTapComposer-module-scss-module__p3KxnW__footer",
  "footerSection": "TipTapComposer-module-scss-module__p3KxnW__footerSection",
  "mentionAILabel": "TipTapComposer-module-scss-module__p3KxnW__mentionAILabel",
  "messageComposer": "TipTapComposer-module-scss-module__p3KxnW__messageComposer",
  "overlay": "TipTapComposer-module-scss-module__p3KxnW__overlay",
  "thread": "TipTapComposer-module-scss-module__p3KxnW__thread",
  "viewer": "TipTapComposer-module-scss-module__p3KxnW__viewer",
});
